export default __webpack_public_path__ + "static/media/service_11.9091eb3b.jpg";